export default __webpack_public_path__ + "static/media/ic_shopping_cart.27fff0db.svg";